import { render, staticRenderFns } from "./InstagramStoriesViewer.vue?vue&type=template&id=07bc3f38"
import script from "./InstagramStoriesViewer.vue?vue&type=script&lang=js"
export * from "./InstagramStoriesViewer.vue?vue&type=script&lang=js"
import style0 from "./InstagramStoriesViewer.vue?vue&type=style&index=0&id=07bc3f38&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InstagramLogo: require('/app/components/InstagramLogo.vue').default})
